import { Box, Container, Grid, Skeleton, styled } from "@mui/material";

export default function ConvertTradeSkeleton() {
  return (
    <Container maxWidth="md">
      <Grid container spacing={2} mt={2}>
        <Grid xs={12} md={12} item>
          <ConvertFormBox>
            <Box display="flex" justifyContent="center" pb={2}>
              <Skeleton variant="rounded" width="40%" height={20} />
            </Box>

            <Box display="flex" justifyContent="center" pb={2}>
              <Skeleton variant="rounded" width="80%" height={10} />
            </Box>

            <Box display="flex" justifyContent="center" pb={2}>
              <Skeleton variant="rounded" width="100%" height={30} />
            </Box>

            <Box pb={1}>
              <Skeleton variant="rounded" width="20%" height={10} />
            </Box>

            <Box pb={2}>
              <Skeleton variant="rounded" width="100%" height={50} />
            </Box>

            <Box pb={1}>
              <Skeleton variant="rounded" width="20%" height={10} />
            </Box>

            <Box pb={2}>
              <Skeleton variant="rounded" width="100%" height={50} />
            </Box>

            <Box>
              <Skeleton variant="rounded" width="100%" height={40} />
            </Box>
          </ConvertFormBox>
        </Grid>
      </Grid>
    </Container>
  );
}
const ConvertFormBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: "8px",
  background:theme.palette.background.convertTrade
}));
